var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-0 page page-active-delivery"},[_c('v-container',{attrs:{"fluid":""}},[_c('transition',{attrs:{"name":"fade-flash","mode":"out-in"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }